import React, { useContext, useMemo, useEffect, useState } from 'react';
import { formatNumWithKMB, getConfig } from 'utils/helperMethods';
import Button from 'components/atoms/Button';
import { CustomModal } from 'CustomComponentCss';
import { CustomSelect } from 'CustomComponentCss';
import DownSvg from 'assets/svg/Down';
import { Spin } from 'antd';
import { UserContext } from 'contexts/ConfigContext';
import { Popover } from 'antd';
import { default as CalenderIcon } from 'assets/svg/Calender';
import Calender from 'components/molecules/Calender';
import dayjs from 'dayjs';
import { useFetchSummaryData } from 'hooks/promoRecommendation/useFetchSummaryData';
import { antIcon } from 'components/molecules/Filter/FilterApplyButton';
import useOptimismPlan from 'hooks/promoRecommendation/useOptimisePlan';

type props = {
    selectedPlan?: any;
    openOptimizeDialogBox: any;
    setOpenOptimizeDialogBox: any;
    onOptimizeComplete: Function;
};

const OptimizeScenarioModel = ({
    selectedPlan,
    openOptimizeDialogBox,
    setOpenOptimizeDialogBox,
    onOptimizeComplete,
}: props) => {
    const { appConfig: config } = useContext(UserContext);
    const { maximizeList } = config.promoRecommendation;
    type DateRangeType = [Date | null, Date | null];
    const [isOpen, setIsOpen] = useState(false);
    const currentDate = new Date();
    const commonConfig = getConfig('commonConfig', config);
    const [stateForCalender, setStateForCalender] = useState({ step: 1, dateRange: [null] });
    const [tempRange, setTempRange] = useState<any>([null]);
    const [maximizeOption, setMaximizeOption] = useState<any>();

    const [promoTradeMax, setPromoTradeMax] = useState<any>();
    const [promoTradeMin, setPromoTradeMin] = useState<any>();
    const [tradeRateSpendMin, setTradeRateSpendMin] = useState<any>();
    const [tradeRateSpendMax, setTradeRateSpendMax] = useState<any>();
    const [retailMarginMin, setRetailMarginMin] = useState<any>();
    const [retailMarginMax, setRetailMarginMax] = useState<any>();
    const [minTotalRoi, setMinTotalRoi] = useState<any>();
    const [minEventRoi, setMinEventRoi] = useState<any>();
    const [netSalesValueMin, setNetSalesValueMin] = useState<any>();
    const [netSalesValueMax, setNetSalesValueMax] = useState<any>();
    const [retailerSalesMin, setRetailerSalesMin] = useState<any>();
    const [retailerSalesMax, setRetailerSalesMax] = useState<any>();
    const [netPriceMin, setNetPriceMin] = useState<any>();
    const [netPriceMax, setNetPriceMax] = useState<any>();
    const {
        data: summaryData,
        loading: optimizeOriginalLoading,
        error: summaryError,
        fetchSummaryData,
    } = useFetchSummaryData();

    const {
        optimizePlan,
        loading: optimizePlanLoading,
        error: optimizePlanError,
        setError: setOptimizePlanError,
    } = useOptimismPlan({ onComplete: onOptimizePlanComplete });

    //called when optimize plan is completed
    function onOptimizePlanComplete() {
        onOptimizeComplete();
        setOpenOptimizeDialogBox();
    }

    const handleDateChange = (range: DateRangeType) => {
        setTempRange([...range]);
    };

    const handleCancel = () => {
        setOpenOptimizeDialogBox(false);
    };

    const optimizeOriginalData: any = useMemo(() => {
        if (summaryData?.length > 0) {
            const data: any = {};
            console.log(summaryData, 'logging f');
            data.percentageTradeRate =
                formatNumWithKMB(
                    summaryData?.find((i: any) => i.KPI === '% Trade Spends')?.[selectedPlan.planName]?.val,
                ) || '-';
            data.totalTradeSpend = formatNumWithKMB(
                summaryData?.find((i: any) => i.KPI === 'Promo Spends')?.[selectedPlan.planName]?.val,
            );
            data.retailMargin = formatNumWithKMB(
                summaryData?.find((i: any) => i.KPI === 'Total Retailer Profit')?.[selectedPlan.planName]?.val,
            );
            data.netSalesValue =
                formatNumWithKMB(
                    summaryData?.find((i: any) => i.KPI === 'Net Sales Value')?.[selectedPlan.planName]?.val,
                ) || '-';
            data.retailerSalesValue =
                formatNumWithKMB(
                    summaryData?.find((i: any) => i.KPI === 'Retailer Sales')?.[selectedPlan.planName]?.val,
                ) || '-';
            data.netPrice =
                formatNumWithKMB(summaryData?.find((i: any) => i.KPI === 'Net Price')?.[selectedPlan.planName]?.val) ||
                '-';
            return data;
        }
        return {};
    }, [summaryData]);

    //only call api once during the load of screen and if retailer present
    useEffect(() => {
        if (openOptimizeDialogBox) {
            fetchSummaryData({
                variables: {
                    planIds: [selectedPlan?.planId],
                    timePeriod: 'full_year',
                    from: 'optimize_scenario',
                },
            });
            setStateForCalender({ step: 1, dateRange: [null] });
            setTempRange([null]);
            setMaximizeOption(null);
            setPromoTradeMin('');
            setPromoTradeMax('');
            setTradeRateSpendMin('');
            setTradeRateSpendMax('');
            setRetailMarginMin('');
            setRetailMarginMax('');
            setMinTotalRoi('');
            setMinEventRoi('');
        }
    }, [openOptimizeDialogBox]);

    const handleOpenChange = (
        newOpen: boolean,
        isClickOutside: boolean = true,
        from: 'header' | 'dateRange' = 'dateRange',
    ) => {
        setIsOpen(newOpen);
        if (!newOpen && !isClickOutside) {
            //only save the date when clicked on set date button
            const date = dayjs(new Date(tempRange[1])).format('YYYY-MM-DD');
            setStateForCalender((prev: any) => ({ ...prev, dateRange: tempRange }));
            // changeInSelection('startDate', date);
            // changeInSelection('month', dayjs(new Date(tempRange[1])).format('MMM'));
        } else if (!newOpen) setTempRange([...stateForCalender.dateRange]); //if clicked outside dont save the change
    };

    const dateLabel = useMemo(() => {
        let startLabel = 'Start Date';
        const { dateRange } = stateForCalender;
        if (dateRange[1]) startLabel = dayjs(new Date(dateRange[1])).format(commonConfig?.dateFormat);
        return { startLabel };
    }, [stateForCalender]);

    const onOptimizePlan = () => {
        optimizePlan({
            variables: {
                planId: selectedPlan?.planId,
            },
        });
    };

    //modal footer
    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Cancel'} onClick={() => {}} style={{ padding: '0px 20px' }} disabled={false} />

                <Button
                    title={
                        optimizePlanLoading ? (
                            <div className="flex justify-center items-center">
                                <Spin indicator={antIcon} />
                            </div>
                        ) : (
                            'Run Optimization'
                        )
                    }
                    onClick={onOptimizePlan}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                    disabled={optimizeOriginalLoading}
                />
            </div>
        );
    };

    return (
        <CustomModal
            title="Optimize"
            open={openOptimizeDialogBox}
            width={583}
            onCancel={handleCancel}
            centered
            footer={Footer()}
            maskClosable={false}
        >
            <div className="px-4">
                <div className="flex justify-between items-center">
                    <div className="flex flex-col mb-2 ">
                        <span className="text-dark font-xs">
                            <span className="mr-2 font-bold">Objective</span>
                        </span>
                        <CustomSelect
                            style={{ width: '170px' }}
                            suffixIcon={<DownSvg />}
                            value={maximizeOption}
                            placeholder="Select"
                            options={maximizeList}
                            className="dropdown-height dropdown-width-alt"
                            onChange={(val: any, item: any) => {
                                setMaximizeOption(item);
                            }}
                            onSelect={(value) => {}}
                        />
                    </div>

                    <div className="flex flex  mb-4 justify-between">
                        <span className="text-dark font-xs flex flex-col">
                            <span className="mr-2 font-bold">Start Date </span>
                            <div style={{ width: '170px' }} className="col-span-6 flex justify-end">
                                <Popover
                                    trigger="click"
                                    open={isOpen}
                                    onOpenChange={(newOpen, e) => handleOpenChange(newOpen, true)}
                                    placement={'right'}
                                    content={
                                        <Calender
                                            minYear={currentDate.getFullYear()}
                                            startYear={currentDate.getFullYear()}
                                            maxYear={currentDate.getFullYear() + 2}
                                            disabledDates={[dayjs(currentDate).format('MM-DD-YYYY'), null]}
                                            startDay={'Monday'}
                                            range={tempRange}
                                            onChange={handleDateChange}
                                            onFooterClick={() => handleOpenChange(false, false)}
                                            singleDateSelect={true}
                                        />
                                    }
                                >
                                    <div className="flex  items-center w-full">
                                        <div className="cursor-pointer w-full flex justify-start gap-1 py-1 items-center px-1 border border-purpleFont rounded">
                                            <CalenderIcon />

                                            <div className="flex w-full">
                                                <span
                                                    className={`
                                                ${
                                                    !stateForCalender.dateRange.includes(null) && !isOpen
                                                        ? 'text-subHeaderColor'
                                                        : dateLabel.startLabel !== 'Start Date'
                                                        ? 'text-greyFont'
                                                        : 'text-borderGrey'
                                                }
                                                font-xs`}
                                                >
                                                    {dateLabel.startLabel}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        </span>
                    </div>
                </div>

                <div>
                    <span className="mr-2 mb-1 font-bold font-xs ">Constraints</span>
                    <>
                        {optimizeOriginalLoading ? (
                            <div
                                className="border-collapse border border-borderGrey  mb-4 rounded-t text-purpleFont overflow-auto flex justify-center items-center"
                                style={{ height: '262px' }}
                            >
                                <Spin />
                            </div>
                        ) : (
                            // KPI TABLE
                            <div
                                style={{ height: '262px' }}
                                className="border-collapse border border-borderGrey mt-2 mb-4 rounded-t text-purpleFont overflow-auto"
                            >
                                <div className="flex w-full justify-between bg-bgBackground border-b-1 border-borderGrey rounded font-medium sticky top-0 z-[100]">
                                    <div className="flex w-full cursor-pointer">
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-4">
                                                <span>KPI</span>
                                            </div>
                                            <div className="w-1/3 text-center">Original Value</div>
                                            <div className="w-1/3 text-center mr-3">Input</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex w-full ">
                                            <div className="flex py-2 w-full">
                                                <div className="w-1/3 ml-2 font-xs">
                                                    <span>% Promo Trade Rate</span>
                                                </div>
                                                <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                    {optimizeOriginalData?.percentageTradeRate}
                                                </div>

                                                <div className="w-1/3 flex">
                                                    <span
                                                        className="flex justify-center items-end gap-2"
                                                        style={{ width: '170px' }}
                                                    >
                                                        <span className="border border-purpleFont rounded mr-1">
                                                            <input
                                                                className="m-0.5 focus:outline-none pl-1  "
                                                                style={{ width: '35px', height: '14px' }}
                                                                value={promoTradeMin}
                                                                placeholder="min"
                                                                onChange={(e: any) => {
                                                                    setPromoTradeMin(e.target.value);
                                                                }}
                                                            />
                                                        </span>
                                                        -
                                                        <span className="border border-purpleFont rounded ml-1">
                                                            <input
                                                                className="m-0.5 focus:outline-none pl-1 "
                                                                style={{ width: '35px', height: '14px' }}
                                                                value={promoTradeMax}
                                                                placeholder="max"
                                                                onChange={(e: any) => {
                                                                    setPromoTradeMax(e.target.value);
                                                                }}
                                                            />
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2 font-xs">
                                                <span>Total Trade Spend</span>
                                            </div>
                                            <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                {optimizeOriginalData?.totalTradeSpend}
                                            </div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="flex justify-center items-end gap-2"
                                                    style={{ width: '170px' }}
                                                >
                                                    <span className="border border-purpleFont rounded mr-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1  "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={tradeRateSpendMin}
                                                            placeholder="min"
                                                            onChange={(e: any) => {
                                                                setTradeRateSpendMin(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                    -
                                                    <span className="border border-purpleFont rounded ml-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1 "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={tradeRateSpendMax}
                                                            placeholder="max"
                                                            onChange={(e: any) => {
                                                                setTradeRateSpendMax(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2 font-xs">
                                                <span>Retailer Margin</span>
                                            </div>
                                            <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                {optimizeOriginalData?.retailMargin}
                                            </div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="flex justify-center items-end gap-2"
                                                    style={{ width: '170px' }}
                                                >
                                                    <span className="border border-purpleFont rounded mr-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1  "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={retailMarginMin}
                                                            placeholder="min"
                                                            onChange={(e: any) => {
                                                                setRetailMarginMin(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                    -
                                                    <span className="border border-purpleFont rounded ml-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1 "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={retailMarginMax}
                                                            placeholder="max"
                                                            onChange={(e: any) => {
                                                                setRetailMarginMax(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* min total Roi */}
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex w-full ">
                                            <div className="flex py-2 w-full">
                                                <div className="w-1/3 ml-2">
                                                    <span>Minimum Total ROI</span>
                                                </div>
                                                <div className="w-1/3 ml-2  flex justify-end mr-20 pr-4">-</div>

                                                <div className="w-1/3 flex">
                                                    <span
                                                        className="border border-purpleFont rounded"
                                                        style={{ width: '164px' }}
                                                    >
                                                        <input
                                                            onWheel={(e) => e.currentTarget?.blur()}
                                                            min={'0'}
                                                            className="m-0.5 focus:outline-none pl-1 pl-2"
                                                            style={{ width: '90%' }}
                                                            placeholder="Enter Min Total ROI"
                                                            disabled={false}
                                                            value={minTotalRoi}
                                                            onChange={(e: any) => setMinTotalRoi(e.target.value)}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* min event roi */}
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2">
                                                <span>Minimum Event ROI</span>
                                            </div>
                                            <div className="w-1/3 ml-2  flex justify-end mr-20 pr-4">-</div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="border border-purpleFont rounded"
                                                    style={{ width: '164px' }}
                                                >
                                                    <input
                                                        onWheel={(e) => e.currentTarget?.blur()}
                                                        min={'0'}
                                                        value={minEventRoi}
                                                        className="m-0.5 focus:outline-none pl-1 pl-2"
                                                        style={{ width: '90%' }}
                                                        placeholder="Enter Min Event ROI"
                                                        disabled={false}
                                                        onChange={(e: any) => setMinEventRoi(e.target.value)}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* {net sales value} */}
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2 font-xs">
                                                <span>Net Sales Value</span>
                                            </div>
                                            <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                {optimizeOriginalData?.netSalesValue}
                                            </div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="flex justify-center items-end gap-2"
                                                    style={{ width: '170px' }}
                                                >
                                                    <span className="border border-purpleFont rounded mr-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1  "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={netSalesValueMin}
                                                            placeholder="min"
                                                            onChange={(e: any) => {
                                                                setNetSalesValueMin(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                    -
                                                    <span className="border border-purpleFont rounded ml-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1 "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={netSalesValueMax}
                                                            placeholder="max"
                                                            onChange={(e: any) => {
                                                                setNetSalesValueMax(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* retailer sales */}
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2 font-xs">
                                                <span>Retailer Sales</span>
                                            </div>
                                            <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                {optimizeOriginalData?.retailerSalesValue}
                                            </div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="flex justify-center items-end gap-2"
                                                    style={{ width: '170px' }}
                                                >
                                                    <span className="border border-purpleFont rounded mr-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1  "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={retailerSalesMin}
                                                            placeholder="min"
                                                            onChange={(e: any) => {
                                                                setRetailerSalesMin(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                    -
                                                    <span className="border border-purpleFont rounded ml-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1 "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={retailerSalesMax}
                                                            placeholder="max"
                                                            onChange={(e: any) => {
                                                                setRetailerSalesMax(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* net price */}
                                <div className="flex w-full justify-between flex-col">
                                    <div
                                        style={{ height: '43px' }}
                                        className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    >
                                        <div className="flex py-2 w-full">
                                            <div className="w-1/3 ml-2 font-xs">
                                                <span>Net Price</span>
                                            </div>
                                            <div className="w-1/3 ml-2 flex justify-end mr-20">
                                                {optimizeOriginalData?.netPrice}
                                            </div>

                                            <div className="w-1/3 flex">
                                                <span
                                                    className="flex justify-center items-end gap-2"
                                                    style={{ width: '170px' }}
                                                >
                                                    <span className="border border-purpleFont rounded mr-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1  "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={netPriceMin}
                                                            placeholder="min"
                                                            onChange={(e: any) => {
                                                                setNetPriceMin(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                    -
                                                    <span className="border border-purpleFont rounded ml-1">
                                                        <input
                                                            className="m-0.5 focus:outline-none pl-1 "
                                                            style={{ width: '35px', height: '14px' }}
                                                            value={netPriceMax}
                                                            placeholder="max"
                                                            onChange={(e: any) => {
                                                                setNetPriceMax(e.target.value);
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                </div>
            </div>
        </CustomModal>
    );
};

export default OptimizeScenarioModel;
